/**
 * The lead form's bot check (R23, KTD7): reCAPTCHA v3 with FTP's site key, as
 * FTP's forms_survey_body_mobile.php does it (script at line 303, execute with
 * action 'saveContent' at submit, 368-375). The API verifies the token and
 * only tags a suspected bot's lead; it never blocks.
 *
 * Nothing here may stop a submit: a script that never loaded, an execute that
 * fails (e.g. this host is not registered to the key) or one that hangs all
 * give an empty token, which the API counts as not spam.
 */

/** FTP's reCAPTCHA v3 site key; the API's EFormSpamCheck::SITE_KEY. */
export const RECAPTCHA_SITE_KEY = '6LctHO0qAAAAAClZkX44Od-WFlJYJIEgQbOFZRQO'

const SCRIPT_ID = 'recaptcha-v3-script'
const EXECUTE_TIMEOUT_MS = 5000

interface Grecaptcha {
  ready: (cb: () => void) => void
  execute: (siteKey: string, options: { action: string }) => Promise<string>
}

export function loadRecaptcha(): void {
  if (document.getElementById(SCRIPT_ID)) return
  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`
  script.async = true
  document.head.appendChild(script)
}

/** A token for this submit, or '' when reCAPTCHA cannot give one. Never rejects. */
export async function recaptchaToken(): Promise<string> {
  const grecaptcha = (window as unknown as { grecaptcha?: Grecaptcha }).grecaptcha
  if (!grecaptcha?.ready || !grecaptcha.execute) return ''

  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    const token = await Promise.race([
      new Promise<string>((resolve, reject) => {
        grecaptcha.ready(() => {
          grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'saveContent' }).then(resolve, reject)
        })
      }),
      new Promise<string>((resolve) => {
        timer = setTimeout(() => resolve(''), EXECUTE_TIMEOUT_MS)
      }),
    ])
    return typeof token === 'string' ? token : ''
  } catch {
    return ''
  } finally {
    if (timer) clearTimeout(timer)
  }
}
